'use client'
import { URL_ICON } from '@/constants/ui'
import { Box, Stack, Typography } from '@mui/material'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import { useEffect, useState } from 'react'
import { FacebookShareButton } from 'react-share'

export const ShareSocials = () => {
  const t = useTranslations()
  const [fullUrl, setFullUrl] = useState('')

  useEffect(() => {
    const url = window.location.href
    setFullUrl(url)
  }, [])
  const SOCIAL_LINKS_BOTTOM = [
    {
      ShareIcon: () => {
        return (
          <FacebookShareButton url={fullUrl} hashtag="#hydra">
            <Image src={'/assets/icons/facebook.png'} alt={'facebook'} width={24} height={24} sizes="48px" />
          </FacebookShareButton>
        )
      },
    },
    // { icon: '/assets/icons/youtube.png', link: SOCIAL_LINKS.youtube, alt: 'youtube' },
  ]
  return (
    <Stack direction="row" alignItems={'center'} spacing={1}>
      <Box sx={{ xs: 'none', sm: 'block' }}>
        <Image width={16} height={16} src={`${URL_ICON}share.svg`} alt="Share" />
      </Box>
      <Typography variant="body2" sx={{ fontWeight: 600 }}>
        {t('Chia sẻ')}:{' '}
      </Typography>
      <Stack
        alignItems={'center'}
        direction={'row'}
        spacing={'4px'}
        sx={{ p: '4px', borderRadius: '999px', backgroundColor: '#F4F5F8' }}
      >
        {SOCIAL_LINKS_BOTTOM.map((Component, index) => (
          <Box
            key={index}
            sx={{ display: 'inline-block', width: '28px', height: '28px', p: '4px', cursor: 'pointer' }}
          >
            <Component.ShareIcon />
          </Box>
        ))}
      </Stack>
    </Stack>
  )
}
